import {
  post_request,
  get_request_export
} from '../axiosFun';
// 车辆故障
export const fault_type = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/home/fault_type_get_list", params)
};
// 车辆在线数量
export const car_status = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/home/car_status", params)
};
// 车辆类型在线离线数量
export const car_type_online_number = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/home/car_type_online_number", params)
};
// 车辆里程
export const car_mileage = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/home/car_mileage_by_type", params)
};
// 车辆型号数量
export const car_type_number = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/home/car_type_number", params)
};
//统计该系统下的故障详情
export const fault_details_count = (params) => {
  params = {
    row: {
      equipment_name: params.faultName,
      start_time: params.faultStartTime,
      end_time: params.faultEndTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/home/fault_details_count", params)
};
//故障统计导出
export const get_export_fault_details_count = (params) => {
  params = {
    row: {
      equipment_name: params.faultName,
      start_time: params.faultStartTime,
      end_time: params.faultEndTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return get_request_export("/web/home/export_fault_details_count", params)
};
//按照车辆类型统计故障详情的次数
export const fault_details_group_by_car_type = (params) => {
  params = {
    row: {
      equipment_name: params.faultName,
      fault_details: params.faultDetails,
      start_time: params.faultStartTime,
      end_time: params.faultEndTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/home/fault_details_group_by_car_type", params)
};
//车辆故障类型导出
export const get_export_fault_details_group_by_car_type = (params) => {
  params = {
    row: {
      equipment_name: params.faultName,
      fault_details: params.faultDetails,
      start_time: params.faultStartTime,
      end_time: params.faultEndTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return get_request_export("/web/home/export_fault_details_group_by_car_type", params)
};
//按照车辆编号统计故障详情的次数
export const fault_vin_by_equipment_details_type = (params) => {
  params = {
    row: {
      equipment_name: params.faultName,
      fault_details: params.faultDetails,
      car_type: params.carTypeId,
      start_time: params.faultStartTime,
      end_time: params.faultEndTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/home/fault_vin_by_equipment_details_type", params)
};
//车辆故障导出
export const get_export_fault_vin_by_equipment_details_type = (params) => {
  params = {
    row: {
      equipment_name: params.faultName,
      fault_details: params.faultDetails,
      car_type: params.carTypeId,
      start_time: params.faultStartTime,
      end_time: params.faultEndTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return get_request_export("/web/home/export_fault_vin_by_equipment_details_type", params)
};
//根据车辆型号（大分类） 统计小分类
export const car_mileage_small = (params) => {
  params = {
    row: {
      car_class_name: params.mileageName,
      date: params.mileageTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/home/car_mileage_small2", params)
};
//导出车辆类型里程
export const get_export_car_mileage_small = (params) => {
  params = {
    row: {
      car_class_name: params.mileageName,
      date: params.mileageTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return get_request_export("/web/home/export_car_mileage_small2", params)
};
//根据车辆型号（大分类） 统计小分类
export const car_mileage_by_car_type = (params) => {
  params = {
    row: {
      car_class_name: params.mileageName,
      car_type: params.mileageCarType,
      date: params.mileageTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/home/car_mileage_by_car_type", params)
};
//导出车辆里程
export const get_export_car_mileage_by_car_type = (params) => {
  params = {
    row: {
      car_class_name: params.mileageName,
      car_type: params.mileageCarType,
      date: params.mileageTime,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return get_request_export("/web/home/export_car_mileage_by_car_type", params)
};
//车辆型号数量详情
export const car_type_number_detail = (params) => {
  params = {
    row: {
      class_name: params.carNumberName,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/home/car_type_number_detail", params)
};
//导出车辆数量
export const get_export_car_type_number_detail = (params) => {
  params = {
    row: {
      class_name: params.carNumberName,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return get_request_export("/web/home/export_car_type_number_detail", params)
};



// WEBPACK FOOTER //
// ./src/api/index/index.js